import React from 'react';
import PropTypes from 'prop-types';

import AuthenticationContextProvider from "./contexts/auth";


const ContextProviders = ({ children }) => {
    return (
        <AuthenticationContextProvider>
            {children}
        </AuthenticationContextProvider>
    )
}

const ConnectedWidget = (props) => {

    const {
        cognitoRegion,
        cognitoUserPoolId,
        cognitoIdentityPoolId,
        cognitoAppClientId,
        apiBaseUrl
    } = props;

    /*

    Amplify.configure({
        Auth: {
            mandatorySignIn: true,
            region: cognitoRegion,
            userPoolId: cognitoUserPoolId,
            userPoolWebClientId: cognitoAppClientId,
            identityPoolId: cognitoIdentityPoolId,
        },
        API: {
            endpoints: [
                {
                    name: "API",
                    endpoint: `${apiBaseUrl}`
                }
            ]
        }
    })
    */

    return (
        <ContextProviders>
            <h1>WIDGET</h1>
        </ContextProviders>
    )
}



ConnectedWidget.propTypes = {
    cognitoRegion: PropTypes.string.isRequired,
    cognitoUserPoolId: PropTypes.string.isRequired,
    cognitoIdentityPoolId: PropTypes.string.isRequired,
    cognitoAppClientId: PropTypes.string.isRequired,
    apiBaseUrl: PropTypes.string.isRequired
};

export default ConnectedWidget;